import { RequestsFilterState } from './pages/Requests/types';

export const MembersTabs = [
  'all',
  'admins',
  'employees',
  'accountants',
  'locked',
] as const;
export type MembersTab = (typeof MembersTabs)[number];

export const root = '/team';

export const members = `${root}/members`;
export const membersInvite = `${members}/invite`;

export const requests = `${root}/requests`;
export const request = `${requests}/:urlFilterState?/:requestId?`;
export const defaultRequests = `${requests}/pending`;

export const memberRoleTransition = `${members}/:companyUserId/role-transitions`;

export const getRequestPath = (requestId: string, state: RequestsFilterState) =>
  `${requests}/${state}/${requestId}`;

export const getMemberRoleTransitionPath = (companyUserId: string) =>
  `${members}/${companyUserId}/role-transitions`;

export const getMemberTabPath = (tab: MembersTab | null) =>
  tab && tab !== 'all' ? `${members}?tab=${tab}` : members;

export const getStatePath = (state: RequestsFilterState) =>
  `${requests}/${state}`;

export type RequestsRouteParams = {
  requestId?: string;
  urlFilterState: RequestsFilterState;
};

export type MemberRoleTransitionRouteParams = {
  companyUserId: string;
};
